export const unique = (list) => [...new Set(list)];
//# sourceMappingURL=unique.js.map